import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
    selector: 'app-expand-collapse',
    templateUrl: './expand-collapse.component.html',
    styleUrls: ['./expand-collapse.component.scss']

})
export class CollapseComponent {
    @Input() isOpen: boolean;
    @Input() hide?: boolean;
    @Input() id: string;
    @Output() showToggle = new EventEmitter();

    toggle() {
        if (this.hide === true) { return; }
        this.isOpen = !this.isOpen;
        this.showToggle.emit({ isOpen: this.isOpen });
    }
}
